import DropMultiSelectFilter from './drop-multi-select-filter.vue';

export default DropMultiSelectFilter;



// WEBPACK FOOTER //
// ./src/FcComponents/drop-multi-select-filter/index.js